// extracted by css-extract-rspack-plugin
var _1 = "dFLL0WtbEF79IDmHXbOWkA--";
var _2 = "FQ9-b0hxBi-lMYhFXWj8kg--";
var _3 = "_7AHWNX9uYS0WHjkEIC5B4g--";
export { _1 as "line", _2 as "ocrOverlay", _3 as "wrapper" }
